import { ExpertId, MergeSettings, SyncMergeSettings } from 'types/MergeIntegration';
import { post } from '../utilities';
import { API_URL_PREFIX, DEFAULT_TOKEN } from '../utilities/constants';


const getMergeSetting = (payload: ExpertId) => {
    return post(`${API_URL_PREFIX}/merge/company/settings/get`, { ...payload, token: DEFAULT_TOKEN });
};

const postMergeSetting = (payload: MergeSettings) => {
    return post(`${API_URL_PREFIX}/merge/company/settings`, {
        ...payload, token: DEFAULT_TOKEN
    })
};

const deleteMergeSetting = (payload: ExpertId) => {
    return post(`${API_URL_PREFIX}/merge/company/settings/delete`, {
        ...payload, token: DEFAULT_TOKEN
    })
}

const postSyncMergeSettings = (payload: SyncMergeSettings) => {
    return post(`${API_URL_PREFIX}/merge/company/settings/sync`, {
        ...payload, token: DEFAULT_TOKEN
    })
}

const postMagicLink = (payload: ExpertId) => {
    return post(`${API_URL_PREFIX}/merge/company/settings/magicLink`, {
        ...payload, token: DEFAULT_TOKEN
    })
}

export const mergeIntegrationService = {
    getMergeSetting,
    postMergeSetting,
    deleteMergeSetting,
    postSyncMergeSettings,
    postMagicLink
}
